import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../../../components/attachment/AttachmentInlineList"));
const UserCaList = defineAsyncComponent(() => import("./UserCaList"));
const CardBorder = defineAsyncComponent(() => import("../../../../../components/card/CardBorder"));

export const callUserRequestDoc7Attachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_REQUEST_DOC_7_ATTACHMENT", value: searchQuery });
export const callProviderCa = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PROVIDER_CA", value: searchQuery });

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly, menuContext } = props;
    //const { useForm } = data;
    //const { modelRef } = useForm;
    //const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const cardProp = lodash.merge(
                        {
                            title: i18n.global.t("views.company.mgt.tab.7.card1")
                        },
                        conditionFormChecker({ props, data, executeKey: "cardProp", params: { componentKey: "AttachmentInlineList" } })
                    );
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachmentCas`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            group: "CA"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return (
                        <CardBorder {...cardProp}>
                            <AttachmentInlineList {...componentProp}></AttachmentInlineList>
                        </CardBorder>
                    );
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const cardProp = lodash.merge(
                        {
                            title: i18n.global.t("views.company.mgt.tab.7.card2")
                        },
                        conditionFormChecker({ props, data, executeKey: "cardProp", params: { componentKey: "UserCaList" } })
                    );
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}userCas`,
                            fetchCriteria: data.userCa?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "UserCaList" } })
                    );
                    return (
                        <CardBorder {...cardProp}>
                            <UserCaList {...componentProp}></UserCaList>
                        </CardBorder>
                    );
                }
            }
        ]
    });
};
